import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackRemoveFromWishListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/wishList/trackRemoveFromWishList";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackRemoveFromWishList = (
    parameters: PartialSpecific<TrackRemoveFromWishListParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventListTrackerHook(ga.track.removeFromWishList, parameters, options);
};

export default useTrackRemoveFromWishList;
